module.exports = __webpack_public_path__ + "static/img/GU.f35d3472.png";